export default {
  methods: {
    /**후청구 사유 필터 */
    mixinsAdditionPriceReason(reason) {
      if (reason === "delay") return "미배차할증";
      if (reason === "re_dispatch") return "파트너재배차";
      if (reason === "over_weight") return "무게변경";
      if (reason === "pin_change") return "경유지변경";
      if (reason === "bundle") return "묶어가기";
      if (reason === "weather") return "기상할증";
      if (reason === "express") return "급송할증";
      if (reason === "complex") return "복합시설할증";
      if (reason === "special_vehicle") return "화물운임";
      if (reason === "wait") return "대기할증";
      if (reason === "partner_penalty") return "파트너패널티";
      if (reason === "promotion") return "프로모션비";
      if (reason === "express_quality") return "급송품평회";
      if (reason === "express_photo") return "급송스튜디오촬영";
      if (reason === "express_admin_approve") return "급송총무팀승인";
      if (reason === "incorrect") return "고객오기재";
      if (reason === "extra") return "고객협의후인상";
      if (reason === "etc") return "기타";
      return "조회실패";
    },

    /**배송수단 필터 */
    mixinsVehicleType(type) {
      if (type === "car") return "승용차";
      if (type === "bike") return "오토바이";
      return "";
    },

    mixinsFeeTitle(title) {
      if (title === "baseFee") return "기본요금";
      if (title === "distanceFee") return "거리요금";
      if (title === "weightFee") return "무게요금";
      if (title === "waypointsFee") return "경유요금";
      if (title === "deliveryfixedFee") return "백단위절사";
      if (title === "additionalfixedFee") return "백단위절사";
      if (title === "fixedFee") return "백단위절사";
      if (title === "timeChargeFee") return "시간할증";
      if (title === "weatherChargeFee") return "기상할증";
      if (title === "specialDayChargeFee") return "특수일할증";
      if (title === "expressDeliveryFee") return "급송요금";
      if (title === "extraFixedFee") return "백단위절사";
      if (title === "vat") return "부가세";
      if (title === "freightOptionsFee") return "옵션요금";
      if (title === "freightDistanceFee") return "거리별 기본요금";
      return "";
    },

    mixinsItemTitle(item) {
      if (item === "document") return "서류";
      if (item === "smallBox") return "소박스";
      if (item === "bigBox") return "대박스";
      if (item === "etc") return "기타";
      return "";
    },

    mixinsCountItem(item) {
      let count = 0;
      let result = "";

      for (const key in item) {
        const value = item[key];
        if (key !== "weight" && key !== "fragile") {
          if (key === "etc" && value !== null && value !== "") {
            count++;
            if (count >= 2) {
              return "여러개";
            }
            result = `${this.mixinsItemTitle(key)}`;
          }
          if (key !== "etc" && value > 0) {
            count++;
            if (count >= 2) {
              return "여러개";
            }
            result = `${this.mixinsItemTitle(key)} ${item[key]}개`;
          }
        }
      }

      return result;
    },

    //소요시간 필터
    mixinsEstimatedTime(time) {
      const hours = Math.floor(time / 60);
      const minutes = time % 60;

      if (hours === 0) {
        return `${minutes}분 이내 도착`;
      }

      if (minutes === 0) {
        return `${hours}시간 이내 도착`;
      }

      return `${hours}시간 ${minutes}분 이내 도착`;
    },

    //주소지 타이틀 필터
    mixinsPinTitle(idx, length) {
      if (idx === 0) return "출발지";
      if (idx === length - 1) return "도착지";
      return `경유지${idx}`;
    },

    mixinscancelable(status) {
      return [
        "registered",
        "reviewed",
        "confirmed",
        "bid_end",
        "napoleon",
        "waiting"
      ].includes(status)
        ? "ok"
        : "fail";
    },

    mixinsreorderable(status) {
      return ["complete", "canceling", "cancel"].includes(status)
        ? "ok"
        : "fail";
    },

    mixinslocationAvailable(status) {
      return ["waiting", "ongoing"].includes(status) ? "ok" : "fail";
    }
  }
};
